// 严重程度
export const severityList=[
  { code:"S", label:"S", desc: "<p>肯定会引起顾客强烈抱怨和投诉、并可能导致退换车的缺陷。</p>"+
    "<p>1)安全性缺陷:所有因车辆失控或汽车损坏而对驾驶员、乘客、行人及其他人员等造成伤害的缺陷(包括潜在的安全项缺陷)，如制动失灵、底盘件断裂、自燃(车辆腐蚀)。</p>"+
    "<p>2)抛锚类缺陷:造成车辆不能起动，或不能再起动，或车辆停驶的缺陷，如机械、电器、液压原因、指示灯或指示表显示故障、严重的气、液体泄漏等缺陷造成车辆不能起动，或不能再起动要求立刻返修的。</p>"+
    "<p>3)主要总成报废、造成重大经济损失的。</p>"+
    "<p>4)不符合制动、转向等法规要求。</p>"+
    "<p>5)媒体曝光质量问题。</p>"
  },
  { code:"A", label:"A", desc: "</p>肯定会引起顾客抱怨和投诉的影响功能实现缺陷，需要立即进站维修。</p>"+
    "<p>1)导致整车主要性能显著下降。</p>"+
    "<p>2)造成主要零部件损坏，且不能用随车工具和易损备件在短时间(约60min)内修复。</p>"+
    "<p>3)所有会对零件造成损坏，远期造成'功能失效'的缺陷。</p>"
  },
  { code:"B", label:"B", desc: "会引起大部分顾客抱怨的部分功能缺失或严重外观缺陷，可在维修保养时或有计划进站时进行调整或修复。</p>"+
    "<p>1)不会导致主要零部件损坏，并可用随车工具和易损备件或价值很低的零件在短时间(约60min)内修复。</p>"+
    "<p>2)影响正常使用，需要调整或修复。</p>"
  },
  {code:"C", label:"C", desc:"可能会引起极少挑剔顾客抱怨的外观缺陷，极少的顾客抱怨可能会进站调整及修复。<br>"+
    "<p>1)不会导致停驶，尚不影响正常使用，亦不需要更换零部件，可用随车工具在短时间内轻易排除。</p>" +
    "<p>2)未达到正常车辆状态，影响到用户开车心情。</p>"
  }
]

// 严重程度
export const severityListKD=[
  {code:"S", label:"S", desc:"<p>1)直接危及人身安全、违反法律法规或安全标准的缺陷。</p>"+
    "<p>2)核心功能丧失且无法行驶（需步行返程）的缺陷。</p>"+
    "<p>3)发动机 / 变速器 / 后桥 / 三电等主要总成故障导致的无法装配、重大停线。<p>"
  },
  {code:"A", label:"A", desc:"<p>1)影响产品主要功能实现或显著降低使用价值，可能导致产品故障但不直接危及安全的缺陷。</p> "+
    "<p>2)不可返修，或需投入较多人工、第三方返修的缺陷。"
  },
  {code:"B", label:"B", desc:"<p>不影响产品核心功能和安全性，但对产品性能或外观有一定影响，需返工且可快速修复的缺陷。</p>"},
  {code:"C", label:"C", desc:"<p>对产品功能、性能及安全性无影响，仅在外观细节或非关键参数上存在微小偏差的缺陷。</p>"},
]
